import {makeStyles} from "@material-ui/core";

export default makeStyles((theme) => ({
  logoutButton: {
    minWidth: "40px",
    padding: "0",
    marginLeft: "10px",
    minHeight: "40px",
    borderRadius: "40px",
  },
  icon: {
    fill: theme.palette.common.white,
  },
}));
